import { render, staticRenderFns } from "./redirect_mobile.vue?vue&type=template&id=5f80a126&scoped=true"
import script from "./redirect_mobile.vue?vue&type=script&lang=js"
export * from "./redirect_mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f80a126",
  null
  
)

export default component.exports